import { NotificationOutlined, FileExcelOutlined } from "@ant-design/icons";
export const icons = {
  NotificationOutlined: <NotificationOutlined />,
  FileExcelOutlined: <FileExcelOutlined />,
};
